import React, { memo, useCallback } from "react";
import { Button } from "@chakra-ui/react";
import { IS_APPLE } from "modules/utils/Constants";
import colors from "app/colors";
import { UnderlineIcon } from "modules/icons";
import { IQuillFormats } from "modules/quill/use-quill";

interface IProps {
  format: (name: string, value: any) => void;
  activeFormats: IQuillFormats;
}

const ComposeQuillUnderline = ({ format, activeFormats }: IProps) => {
  const isSelected = !!activeFormats.underline;

  const onMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      if (format) {
        format("underline", !isSelected);
      }
    },
    [isSelected, format],
  );

  const bg = isSelected ? colors.gray0 : colors.transparent;

  return (
    <Button
      variant="hover"
      size="sm"
      aria-label="Format text as underline"
      title={IS_APPLE ? "Underline (⌘U)" : "Underline (Ctrl+U)"}
      tabIndex={-1}
      onMouseDown={onMouseDown}
      px={0}
    >
      <UnderlineIcon
        boxSize={5}
        fill={colors.gray40}
        bg={bg}
        borderRadius={4}
      />
    </Button>
  );
};

export default memo(ComposeQuillUnderline);
